<template>
  <UIInputDynamicList
    v-model="actionValue"
    :data
    :size
    :disabled
    @click:new="handleCreate"
  />
</template>

<script setup lang="ts">
import { computed, inject, onBeforeMount, ref } from 'vue'
import { orderBy } from 'lodash'

import { InputSize } from '@types'
import { TaggingRuleAction } from '../utils/types'

import { prepareTagsList } from './utils/helpers'

import { useTagsBunchStore } from '@/store/tags/bunch'

import useFiltersService from '@/services/filters'

import { UIInputDynamicList } from '@ui/fields'

type Props = {
  disabled?: boolean
}

defineProps<Props>()

const modelValue = defineModel<TaggingRuleAction>({
  required: true,
})

const tagsBunchStore = useTagsBunchStore()

const { fetchOptions } = useFiltersService()

const size = inject<InputSize>('size')

const existingList = ref<string[]>([])

const tagsList = computed(() =>
  prepareTagsList(tagsBunchStore.getCategoriesList),
)

const data = computed(() =>
  orderBy([...new Set([...existingList.value, ...tagsList.value])]).map(
    value => ({
      value,
      label: value,
    }),
  ),
)

const actionValue = computed({
  get() {
    return modelValue.value.value
  },
  set(value) {
    modelValue.value = {
      ...modelValue.value,
      value: value || '',
    }
  },
})

const handleCreate = (value: string, callback: () => void) => {
  existingList.value.push(value)
  actionValue.value = value
  callback()
}

onBeforeMount(async () => {
  existingList.value = (
    await fetchOptions('LinkedDataTransactions', 'category')
  ).map(item => item.value)
  if (actionValue.value !== undefined) {
    existingList.value.push(actionValue.value)
    return
  }
  actionValue.value = ''
})
</script>
